'use client';

import { Fragment, ReactNode, useEffect } from 'react';
import { useAtom } from 'jotai';
import { ProductCardSkeleton } from '@/components/ProductCard/ProductCardSkeleton';
import { mpProductGridLoadingAtom } from '@/store/atoms';

type MPProductGridSkeletonProps = {
  children: ReactNode;
};

export const MPProductGridSkeleton = ({ children }: MPProductGridSkeletonProps) => {
  const [isLoading, setLoading] = useAtom(mpProductGridLoadingAtom);

  // `children` is a fresh element tree on every server render, so this clears the flag as soon as a
  // navigation lands. Keying it on mount alone is not enough: clearing the search term navigates
  // /shop?query=x -> /shop, which keeps the same route segment and never remounts this component.
  useEffect(() => {
    setLoading(false);
  }, [children, setLoading]);

  if (!isLoading) {
    return <Fragment key="mp-product-grid">{children}</Fragment>;
  }

  return (
    <ul key="mp-product-grid-skeleton" className="grid grid-cols-2 gap-x-2 gap-y-8 md:grid-cols-4">
      {Array.from({ length: 8 }).map((_, i) => (
        <li key={i}>
          <ProductCardSkeleton />
        </li>
      ))}
    </ul>
  );
};
